// TODO Find an approach to Firefox privacy policy
import { loadFacebookSdk, performFacebookIdentification } from "../facebookAuthentication";
import { services } from "../../../../constants";
import { cache } from "../../../persistence/cache";
import { socialProviders } from "../socialProviders";
import { canUpdateToken, updateUserData } from "../tokenOperations";
import { socialAuthenticationErrors } from "../facebookAuthentication/errors";

function getBackendLoginFunction(facebookResponse, config, resolve, reject) {
  return function doBackendLogin() {
    FB.api("/me", { fields: "email" }, async ({ email }) => {
      const { accessToken } = facebookResponse.authResponse;
      if (email === undefined) {
        reject({ error: socialAuthenticationErrors.EMAIL_PERMISSION_NOT_GRANTED, socialUserToken: accessToken });
        return;
      }
      starzLogin.call(this, resolve, reject, accessToken, config, email);
    });
  };
}

async function starzLogin(resolve, reject, socialUserToken, config, username) {
  try {
    const response = await this.http.post(`${this.backendHosts.auth}${services.login}`, {
      userToken: socialUserToken,
      provider: socialProviders.FACEBOOK
    });
    // FIXME The following lines could be repeated somewhere else
    if (canUpdateToken(response)) {
      updateUserData.call(this, response.data.token, response.data.user.globalUserId, config);
    }
    cache.clear({ database: "layouts" });
    resolve(response.data.user);
  } catch (e) {
    const error = this.formatErrorObject(e);
    // FIXME The same way the SDK hides the JWT and other sensitive data, it should not expose socialUserToken. This impacts userManager.mergeAccounts()
    reject({ error, socialUserToken, username });
  }
}

const facebookLogin = {
  run(config) {
    return new Promise(async (resolve, reject) => {
      const { socialUserToken } = config;
      if (socialUserToken) {
        starzLogin.call(this, resolve, reject, socialUserToken, config);
      } else {
        loadFacebookSdk.call(
          this,
          this.identityProviders.facebook.libSrc,
          performFacebookIdentification.bind(this, config, resolve, reject, getBackendLoginFunction)
        );
      }
    });
  }
};

export default facebookLogin;
